import { render, staticRenderFns } from "./requisition.vue?vue&type=template&id=cebe64d2&scoped=true&"
import script from "./requisition.vue?vue&type=script&lang=js&"
export * from "./requisition.vue?vue&type=script&lang=js&"
import style0 from "./requisition.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./requisition.vue?vue&type=style&index=1&id=cebe64d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebe64d2",
  null
  
)

export default component.exports